import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=f9ba848c"
import script from "./Servers.vue?vue&type=script&lang=ts"
export * from "./Servers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports